import { Grid, styled } from '@mui/material'
import React, { ComponentProps } from 'react'

export type FooterWrapperProps = Omit<ComponentProps<typeof Grid>, 'justifyContent' | 'alignItems'> & {
  //
}


export const StyledFooter = styled('footer')`
`

export const FooterWrapper: React.FC<FooterWrapperProps> = ({ children, ...props }) => (
  <StyledFooter>
    <Grid container justifyContent="space-between" alignItems="center" {...props}>
      {children}
    </Grid>
  </StyledFooter>
)
